export default __webpack_public_path__ + "static/media/colgate.60e851d9.png";